// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class Interest {
    constructor(assetId, interestValue, negativeInterestValue) {
        this.assetId = assetId;
        this.updateInterest(interestValue, negativeInterestValue);
    }
    updateInterest(interestValue, negativeInterestValue) {
        this.interestValue = interestValue;
        this.negativeInterestValue = negativeInterestValue;
    }
    get InterestValue() {
        return this.interestValue;
    }
    get NegativeInterestValue() {
        return this.negativeInterestValue;
    }
}
export class InterestPlan {
    constructor() {
        this.interestPlanId = 0;
        this.accountId = 0;
        this.description = '';
        this.name = '';
        this.hasNegativeInterests = false; // for migration purposes
        this.interestDictionary = new Map();
    }
    UpdateByMessage(interestMessage) {
        this.interestPlanId = interestMessage.InterestsOnBalancePlanID;
        this.accountId = interestMessage.CounterAccountID;
        this.description = interestMessage.Description;
        this.name = interestMessage.Name;
        this.hasNegativeInterests = false;
        for (const entry of interestMessage.ListInterestsOnBalancePlanEntryBean) {
            const negativeInterest = entry.NegativeInterest;
            if (negativeInterest != null) {
                this.hasNegativeInterests = true;
            }
            const existing = this.interestDictionary.get(entry.AssetID);
            if (existing) {
                existing.updateInterest(entry.Interest, negativeInterest);
            }
            else {
                this.interestDictionary.set(entry.AssetID, new Interest(entry.AssetID, entry.Interest, negativeInterest));
            }
        }
    }
    getInterestValue(assetId) {
        var _a, _b;
        return (_b = (_a = this.interestDictionary.get(assetId)) === null || _a === void 0 ? void 0 : _a.InterestValue) !== null && _b !== void 0 ? _b : 0;
    }
    getNegativeInterestValue(assetId) {
        var _a, _b;
        return (_b = (_a = this.interestDictionary.get(assetId)) === null || _a === void 0 ? void 0 : _a.NegativeInterestValue) !== null && _b !== void 0 ? _b : 0;
    }
    get HasNegativeInterests() {
        return this.hasNegativeInterests;
    }
    get InterestPlanId() {
        return this.interestPlanId;
    }
    get AccountId() {
        return this.accountId;
    }
    get Description() {
        return this.description;
    }
    get Name() {
        return this.name;
    }
}
